<template>
  <div>
    <template v-if="actions">
      <v-btn
        small
        v-for="(btn, key) in actions"
        :key="key"
        :color="STATUS[key].color"
        :to="STATUS[key].to"
        @click="handlers[STATUS[key].cb](btn.new_status)"
      >
        {{ btn.name }}
      </v-btn>
    </template>

    <template v-if="permissions">
      <v-btn
        small
        v-if="permissions.CONVERT_TO_TRIAL"
        :color="PERMISSIONS.CONVERT_TO_TRIAL.color"
        :to="convertToTrail"
      >
        {{ PERMISSIONS.CONVERT_TO_TRIAL.text }}
      </v-btn>
    </template>
  </div>
</template>

<script>
import { CONST } from '@/utils/index';
import Booking from '@/orm/models/Booking';

const { booking: { META: { PERMISSIONS, STATUS } } } = CONST;

export default {
  name: 'statusActions',
  props: {
    actions: Object,
    permissions: Object,
  },
  data() {
    return {
      PERMISSIONS,
      STATUS,
      handlers: {
        changeStatus: this.onChangeStatus,
      },
    };
  },
  computed: {
    convertToTrail() {
      const { params } = this.$route;
      return {
        name: this.allRoutes.trial.children.trialNew.name,
        params,
      };
    },
  },
  methods: {
    async onChangeStatus(status) {
      if (!status) return;
      try {
        this.setRouteLoadingValue(true);
        const { params } = this.$route;
        const data = await Booking.$update({
          params,
          data: {
            status,
            user_role: this.currentGroup.slug,
          },
        });
        await Booking.insertOrUpdate({ data });
      } finally {
        this.setRouteLoadingValue(false);
      }
    },
  },
};
</script>
